module.exports = __webpack_public_path__ + "static/media/siddharth-mysuru-trip-15.b70405cf.png";